import {useEffect,useRef,useState} from 'preact/hooks';
import {lifeResourceArt,loadLifeArt} from '@/life-skill-art';

export function LifeResourceIcon({graphic,name,size=40}:{graphic:string;name:string;size?:number|'world'}){
  const ref=useRef<HTMLCanvasElement>(null);const [failed,setFailed]=useState(false);
  const art=lifeResourceArt[graphic];
  useEffect(()=>{let cancelled=false;setFailed(false);
    if(art)void loadLifeArt(art).then(image=>{if(!cancelled&&ref.current){const ctx=ref.current.getContext('2d')!;ctx.clearRect(0,0,art.width,art.height);ctx.drawImage(image,0,0);}}).catch(()=>{if(!cancelled)setFailed(true);});
    return()=>{cancelled=true;};
  },[art]);
  if(!art||failed)return <span aria-label={name}>Resource</span>;
  const scale=size==='world'?1:Math.min(size/art.width,size/art.height);
  return <canvas ref={ref} width={art.width} height={art.height} role='img' aria-label={name} style={{imageRendering:'pixelated',width:Math.round(art.width*scale),height:Math.round(art.height*scale),flexShrink:0}}/>;
}
